<template>
  <div class="main-content">
    <div class="px-1 px-md-4 mx-1 mx-md-2">
      <div class="container-fluid">
        <page-header
          :page="{
            icon: 'fa fa-file-invoice',
            title: 'Términos y Condiciones',
            routes: ['Inicio', 'Términos y Condiciones'],
          }"
        />
        <div>
          <div class="main-page-container">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
              euismod non velit dapibus eleifend. Donec non enim vel tellus
              maximus convallis non condimentum velit. Quisque lobortis purus id
              nunc dignissim tincidunt. Nunc metus odio, fermentum ut vehicula
              a, dapibus hendrerit augue. Maecenas quis leo at ex dapibus
              viverra. Ut vitae augue est. Etiam congue eros nisl, vel molestie
              nisi sodales vitae. Cras cursus lorem vitae arcu accumsan euismod.
              Aenean ut est sed sapien pretium maximus.
            </p>
            <p>
              Proin non lacinia odio. Ut lobortis ut tellus ut fringilla. Nulla
              maximus eget nunc a cursus. Nam non diam nec ipsum tristique
              sollicitudin. Pellentesque imperdiet lacus in tortor egestas
              aliquet. Duis ac ligula venenatis, ultrices ex sed, tincidunt
              dolor. Integer convallis ex augue, ac rutrum mi dictum sed.
              Pellentesque habitant morbi tristique senectus et netus et
              malesuada fames ac turpis egestas. Morbi eleifend imperdiet diam
              fringilla convallis. Suspendisse potenti. Proin at metus vitae
              erat tempus accumsan vel quis metus. Mauris vel ornare enim, nec
              rhoncus nulla.
            </p>
            <p>
              Interdum et malesuada fames ac ante ipsum primis in faucibus.
              Pellentesque habitant morbi tristique senectus et netus et
              malesuada fames ac turpis egestas. Nulla vitae nisl in arcu
              condimentum posuere. Aenean blandit sapien quis imperdiet laoreet.
              Donec a tortor non tortor ultricies pulvinar nec sed ligula. Cras
              dignissim urna sit amet dolor fringilla, vel tempor augue
              vestibulum. Sed sollicitudin tempor erat non pharetra. Fusce
              luctus blandit scelerisque. Integer aliquam risus dolor, et
              pulvinar sapien sodales vel. Vestibulum cursus elementum justo, at
              sodales massa ullamcorper vel. Cras mattis, nunc sed scelerisque
              iaculis, odio nunc placerat velit, sit amet sagittis eros arcu ac
              turpis. Donec ac mauris libero. Mauris dignissim tellus quis massa
              faucibus mollis. Cras at tristique nisi, non mollis ipsum.
            </p>
            <p>
              Donec viverra placerat tincidunt. Aenean egestas tellus et nunc
              porta, id tincidunt ligula scelerisque. Sed et diam mollis,
              egestas erat id, accumsan lacus. Nulla at dignissim odio, quis
              tincidunt elit. Praesent aliquam ex tortor, ut rhoncus massa
              porttitor a. Duis eu faucibus odio. Proin ullamcorper scelerisque
              posuere. Vestibulum auctor sagittis scelerisque. Integer diam
              lectus, lacinia vel leo sed, dictum ullamcorper ligula. Curabitur
              tincidunt sed ex non tincidunt. Ut at mi ut elit pretium semper.
              Vestibulum auctor, lectus ut fermentum varius, odio metus
              vulputate justo, quis tempor nisi ex non tortor. Curabitur laoreet
              justo a quam posuere cursus. Proin hendrerit nibh ut mauris porta,
              nec porta quam pharetra. Donec vitae diam sed leo luctus pulvinar.
            </p>
            <p>
              Mauris ut turpis eu ex placerat commodo. Morbi et varius ligula.
              Suspendisse potenti. Morbi et commodo lorem. Morbi facilisis magna
              ligula, id malesuada nisl laoreet sit amet. Class aptent taciti
              sociosqu ad litora torquent per conubia nostra, per inceptos
              himenaeos. Nullam a lacus sed risus porttitor venenatis nec at
              arcu.
            </p>
          </div>
        </div>
        <div class="clear" />
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
export default {
  name: 'TermsAndConditions',
  components: {
    PageHeader,
  },
};
</script>

<style lang="scss">
.main-content {
  padding-top: 20px;
  padding-bottom: 20px;
}
.fab-wrapper {
  display: none !important;
}
</style>
